import { Skeleton } from '@ria-client/tw-shadcn/components/skeleton';

export function GeoDropdownSkeleton() {
  return <Skeleton className="min-h-[68px] w-full rounded sm:w-[213px]" />;
}
